export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const CLEAR_CURRENT_USER = "CLEAR_CURRENT_USER";
export const SET_PROFILE_DATA = "SET_PROFILE_DATA";
export const SET_TRANSACTION_DATA = "SET_TRANSACTION_DATA";
export const SHOW_MODAL = "SHOW_MODAL";
export const CLOSE_SHOW_MODAL = "CLOSE_SHOW_MODAL";
